import styled from 'styled-components/macro'

export const Container = styled.section`
  padding: 1.6rem;
  width: 100%;
  max-width: 144rem;
  margin: 0 auto;
`

export const Title = styled.h1`
  margin: 3.2rem 0 1.6rem;
  font-weight: ${(props) => props.theme.font.weight.bold};
  font-size: 2.4rem;
  line-height: 1.44;
  text-align: center;
  color: ${(props) => props.theme.color.text};
  ${(props) => props.theme.breakpoints.greaterThan('sm')`
     font-size: 3.2rem;
  `};
`

export const ContentWrap = styled.div`
  width: 100%;
`
